import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  CLOSE_BANNER_DIALOG,
  CREATE_NEW_BANNER,
  DELETE_BANNER,
  EDIT_BANNER,
  GET_BANNER,
  SHOW_HOME_SWITCH,
  SHOW_ROOM_SWITCH,
  VIP_SWITCH,
} from "./types";

export const getBanner = () => (dispatch) => {
  axios
    .get(`banner/all`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_BANNER, payload: res.data.banner });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const handleSwitchShowInRoom = (bannerId) => (dispatch) => {
  axios
    .put(`banner/room/${bannerId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: SHOW_ROOM_SWITCH, payload: res.data.banner });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const handleSwitchShowInHome = (bannerId) => (dispatch) => {
  axios
    .put(`banner/home/${bannerId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: SHOW_HOME_SWITCH, payload: res.data.banner });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const createNewBanner = (data) => (dispatch) => {
  axios
    .post(`banner`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Banner created successfully!");
        dispatch({ type: CLOSE_BANNER_DIALOG });
        dispatch({ type: CREATE_NEW_BANNER, payload: res.data.banner });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const editBanner = (bannerId, data) => (dispatch) => {
  console.log("bannerId", bannerId);
  for (const pair of data.entries()) {
    console.log(`${pair[0]}, ${pair[1]}`);
  }
  axios
    .post(`banner/update?bannerId=${bannerId}`, data)
    .then((res) => {
      console.log("res update: ", res)
      if (res.data.status) {
        Toast("success", "Banner updated successfully!");
        dispatch({ type: CLOSE_BANNER_DIALOG });
        dispatch({
          type: EDIT_BANNER,
          payload: { data: res.data.banner, id: bannerId },
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error update: ", error)
      Toast("error", error.message)
    });
};
export const deleteBanner = (bannerId) => (dispatch) => {
  axios
    .delete(`banner/${bannerId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: DELETE_BANNER, payload: bannerId });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};
